import FormRow from "MODULES/shared/components/Forms/FormRow";
import T from "prop-types";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";
import { COMPANY_ID, CONTACT_ID } from "APP_ROOT/constants";
import {
  FormInput,
  PhoneNumberField,
  Select
} from "MODULES/shared/components/Forms";
import React, { useState } from "react";
import { searchContacts } from "MODULES/parts/actions";
import { searchCompanies } from "MODULES/PurchaseOrders/actions";
import DoNotDoBusinessWarning from "MODULES/parts/components/Detail/IncomingQuotes/Create/DoNotDoBusinessWarning";
import { generateUUID } from "LIB/uuid";
import AutoComplete from "../../../../shared/components/AutoComplete";

function CompanyRow({ getFieldValue, item, idx, remove, setFieldValue }) {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [contacts, setContacts] = useState([]);

  const contact = getFieldValue(`${item}.${CONTACT_ID}`);

  const fetchContacts = value => {
    if (!value) {
      return null;
    }

    return searchContacts(value).then((vals = []) => {
      setContacts(vals);

      const primaryContact = vals.find(con => con.primary);

      if (primaryContact) {
        setFieldValue(`${item}.${CONTACT_ID}`)(primaryContact.id);
      }
    });
  };

  const handleCompanySelected = result => {
    setFieldValue(`${item}.${COMPANY_ID}`)(result ? result.id : null);
    setSelectedCompany(result);
    fetchContacts(result && result.id);
  };

  const addContact = contact === "Add";

  return (
    <div>
      <FormRow>
        <DoNotDoBusinessWarning company={selectedCompany} />
        <Col md={5}>
          <label className="control-label" htmlFor="company">
            Company
          </label>
          <AutoComplete
            name={`${item}.${COMPANY_ID}`}
            value={selectedCompany ? selectedCompany.name : ""}
            search={filter => searchCompanies(filter)()}
            onSelect={handleCompanySelected}
            format={result => result.name}
            placeholder="Search by typing a company's name or code"
          />
        </Col>
        <Col md={5}>
          <div className="form-group">
            <Field
              name={`${item}.${CONTACT_ID}`}
              component={Select}
              options={contacts.map(r => ({ value: r.id, text: r.name }))}
              label="Contact"
              required
            />
          </div>
        </Col>
        <Col md={2}>
          {
            <span
              className="fa fa-times red"
              onClick={() => {
                setTimeout(() => remove(idx), 0);
              }}
            />
          }
        </Col>
      </FormRow>

      {addContact && (
        <FormRow>
          <Col md={4}>
            <div className="form-group">
              <Field
                name={`${item}.contact.name`}
                component={FormInput}
                label="Contact Name"
                required
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <Field
                name={`${item}.contact.email`}
                component={FormInput}
                label="Contact Email"
                required
              />
            </div>
          </Col>
          <Col md={4}>
            <PhoneNumberField
              name={`${item}.contact.phone1`}
              component={FormInput}
              label="Phone Number 1"
              type="tel"
            />
          </Col>
        </FormRow>
      )}
    </div>
  );
}

function CompanyRows({ fields, getFieldValue, setFieldValue }) {
  return (
    <div>
      {fields.map((item, idx) => (
        <CompanyRow
          key={getFieldValue(`${item}.id`)}
          idx={idx}
          item={item}
          getFieldValue={getFieldValue}
          setFieldValue={setFieldValue}
          remove={fields.remove}
        />
      ))}
      <Row>
        <Col md={12}>
          <button
            type="button"
            className="btn btn-default  btn-hollow"
            onClick={() =>
              fields.push({
                id: generateUUID(),
                contact_id: null,
                company_id: null
              })}
          >
            <span className="fa fa-plus" /> Add Company
          </button>
        </Col>
      </Row>
    </div>
  );
}

CompanyRows.propTypes = {
  getFieldValue: T.func,
  setFieldValue: T.func
};

export default CompanyRows;



// WEBPACK FOOTER //
// ./app/modules/parts/components/IncomingQuoteLineItems/CreateMultiVendorQuote/CompanyRow.jsx